import { transferActionList } from "../../promotion-gdt/subPlan/common/config";
export const formatTableList = (item) => {
  item.ctr !== null && (item.ctr = (item.ctr * 100).toFixed(2) + "%");
  item.attributionConvertRate !== null && (item.attributionConvertRate = (item.attributionConvertRate * 100).toFixed(2) + "%");
  item.convertCntRate !== null && (item.convertCntRate = (item.convertCntRate * 100).toFixed(2) + "%");
  item.deepConversionsRate !== null && (item.deepConversionsRate = (item.deepConversionsRate * 100).toFixed(2) + "%");
  item.downloadRate !== null && (item.downloadRate = (item.downloadRate * 100).toFixed(2) + "%");
  item.installRate !== null && (item.installRate = (item.installRate * 100).toFixed(2) + "%");
  item.activatedRate !== null && (item.activatedRate = (item.activatedRate * 100).toFixed(2) + "%");
  item.clickActivatedRate !== null && (item.clickActivatedRate = (item.clickActivatedRate * 100).toFixed(2) + "%");
  item.retentionRate !== null && (item.retentionRate = (item.retentionRate * 100).toFixed(2) + "%");
  item.dailyBudget = item.dailyBudget === 0 ? "不限" : item.dailyBudget;
  if (item.promotedObjectType?.includes("APP_ANDROID")) {
    item.promotedObjectType = "Android 应用";
  } else if (item.promotedObjectType?.includes("APP_IOS")) {
    item.promotedObjectType = "IOS 应用";
  }
  item.speedMode = item.speedMode === "SPEED_MODE_STANDARD" ? "标准投放" : "加速投放";
  if (item.optimizationGoal) {
    const data = transferActionList.find((child) => child.value === item.optimizationGoal) || {};
    item.optimizationGoal = data ? data.label : "--";
  }
};
